import React from "react";
import { Route, Switch } from "react-router-dom";
import {
  LoginPage,
  ForgotPasswordPage,
  ResetPasswordPage,
  HelpPage,
  ChangesPage
} from "pages";
import ProtectedRoutes from "routes/ProtectedRoutes";

export const Routes: React.FC = () => {
  return (
    <Switch>
      <Route path="/login" component={LoginPage} />
      <Route path="/help" component={HelpPage} />
      <Route path="/changes" component={ChangesPage} />
      <Route path="/forgot-password" component={ForgotPasswordPage} />
      <Route path="/reset-password" component={ResetPasswordPage} />
      <ProtectedRoutes />
    </Switch>
  );
};

export default Routes;
